import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useAcquisitionAnalyticsStore } from '../stores/acquisitionAnalytics.store';
import { channels, mediums } from '../constants/acquisitionConstants';
import getChannelAndMediumFromMailchimp from '../utils/getChannelAndMediumFromMailchimp';

export default function useAcquisitionAnalytics() {
  const router = useRouter();
  const { analytics, setAnalytics } = useAcquisitionAnalyticsStore();

  useEffect(() => {
    if (router.isReady && !analytics) {
      const referrer = document.referrer || '';

      const landingPage = router.asPath;

      const normalizedAnalytics = normalizeAnalytics({
        referrer,
        ...router.query,
        landingPage,
      });

      setAnalytics(normalizedAnalytics);
    }
  }, [router.isReady, analytics]);

  return null;
}

function normalizeAnalytics(rawAnalytics) {
  if (!rawAnalytics) return null;

  const { referrer, utm_source, utm_medium, utm_term, landingPage } =
    rawAnalytics;

  let channel = channels.webDirect;
  let medium = mediums.organic;

  const mailchimp = getChannelAndMediumFromMailchimp(utm_medium, utm_term);

  // First check if it's from mailchimp
  // because it has its own logic for utm parameters
  if (mailchimp) {
    channel = mailchimp.channel;
    medium = mailchimp.medium;
  } else {
    // Then check if it the utm_source is set
    if (utm_source) {
      channel = utm_source;
    } else {
      // Then check if the referrer is a known channel
      const referrerChannel = parseReferrerToChannel(referrer);
      if (referrerChannel) {
        channel = referrerChannel;
      }
    }
    // Finally check if it's a paid medium, otherwise it's organic
    if (utm_medium) {
      medium = mediums.paid;
    }
  }

  return {
    channel,
    medium,
    referrer,
    landingPage,
    metadata: rawAnalytics,
  };
}

function parseReferrerToChannel(referer) {
  if (!referer) return null;

  const lowerReferer = referer.toLowerCase();

  if (lowerReferer.includes(`${channels.google}.`)) return channels.google;
  if (lowerReferer.includes(`${channels.clever}.`)) return channels.clever;
  if (lowerReferer.includes(`${channels.classlink}.`))
    return channels.classlink;
  if (lowerReferer.includes(`${channels.facebook}.`)) return channels.facebook;
  if (lowerReferer.includes(`${channels.youtube}.`)) return channels.youtube;

  return null;
}
